import { createSelector } from "@ngrx/store";
import { IStore } from "../store";

export const getTransactionSiblingsState = createSelector(
    (store: IStore) => store.transactionSiblings,
    store => store,
);
